/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Validation_Installment_CapInputs */

const en_case_payment_validation_installment_cap = /** @type {(inputs: Case_Payment_Validation_Installment_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The installment count exceeds the current client policy.`)
};

const pt_br2_case_payment_validation_installment_cap = /** @type {(inputs: Case_Payment_Validation_Installment_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A quantidade de parcelas excede a política atual do cliente.`)
};

/**
* | output |
* | --- |
* | "The installment count exceeds the current client policy." |
*
* @param {Case_Payment_Validation_Installment_CapInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_validation_installment_cap = /** @type {((inputs?: Case_Payment_Validation_Installment_CapInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Validation_Installment_CapInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_validation_installment_cap(inputs)
	return pt_br2_case_payment_validation_installment_cap(inputs)
});